module.exports = __webpack_public_path__ + "static/media/042.58c7284f.jpg";